import { formatPrice } from '@/utils/number.js';

// Confirmation of the extra brand charge, shown when the backend answers a brand creation or
// reactivation with 402 (PaymentRequiredError): the brand would go over the subscription's brand limit.
export default {
  methods: {
    formatPrice,
    getExtraBrandChargePriceMessage(err) {
      if (err.getNetPrice() === err.getGrossPrice()) {
        return this.tr(
          'We will attempt to automatically deduct the prorated amount of :currentGrossPrice for this billing period from your registered credit card.',
          { ':currentGrossPrice': this.formatPrice(err.getGrossPrice(), '€') },
        );
      }

      return this.tr(
        'We will attempt to automatically deduct the prorated amount of :currentGrossPrice (:currentNetPrice + VAT) for this billing period from your registered credit card.',
        {
          ':currentNetPrice': this.formatPrice(err.getNetPrice(), '€'),
          ':currentGrossPrice': this.formatPrice(err.getGrossPrice(), '€'),
        },
      );
    },
    /**
     * @param {PaymentRequiredError} err
     * @param {{ title: string, intro: string, confirm: Function, cancel?: Function }} options
     *   `intro` is the translated sentence explaining what would exceed the limit.
     */
    openExtraBrandChargeConfirmation(err, { title, intro, confirm, cancel }) {
      const company = this.$root.currentCompany;

      if (this.$app.isShoprenterApp) {
        this.$confirmation.open({
          title,
          content: intro,
          cancel,
        });
        return;
      }

      this.$confirmation.open({
        title,
        content: intro + '<br/>' +
          this.tr(
            'The cost to use an additional brand is :price.',
            { ':price': this.formatPrice(company.current_subscription?.package?.extra_brand_price, '€', company.current_subscription?.package?.period) },
          ) + '<br/><br/>' +
          this.getExtraBrandChargePriceMessage(err),
        labelCancel: this.tr('Cancel'),
        labelConfirm: this.tr('Confirm'),
        confirm,
        cancel,
      });
    },
  },
};
